import { motion } from "framer-motion";

const QuestionAnswerOral = ({
  question,
  recording,
  countdown,
  videoUrl,
  videoRef,
}) => {
  return (
    <div className="col-span-4 flex flex-col items-center gap-4">
      <motion.div
        className="w-full min-h-[50%] max-h-[50%] p-3 border-2 bg-gray-600 text-white border-gray-300 rounded-lg shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-300 transition-all duration-300 resize-none overflow-y-auto whitespace-pre-wrap flex flex-col justify-between"
        whileFocus={{ scale: 1.02 }}
      >
        {/* Top Content */}
        <div>
          {question?.text ? (
            <>
              <span className="text-2xl font-bold">{`Q${question.question_number}. `}</span>
              <span className="text-lg">{question?.text}</span>
            </>
          ) : (
            "Click on start to get questions"
          )}
        </div>

        {/* Bottom Progress Line */}
        {recording && (
          <div className="w-full bg-gray-400 h-1 mt-2 rounded">
            <motion.div
              className={`h-1 rounded ${
                countdown <= 10 ? "bg-red-500" : "bg-green-500"
              }`}
              animate={{ width: `${(countdown / 30) * 100}%` }}
              transition={{ duration: 1, ease: "linear" }}
            />
          </div>
        )}
      </motion.div>

      <motion.div
        className="w-full min-h-[50%] max-h-[50%]"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
      >
        <div className="w-full min-h-[80%] max-h-[80%] border-2 text-white border-gray-300 rounded-lg shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-300 transition-all duration-300 overflow-hidden flex flex-col justify-between">
          {videoUrl && (
            <video
              key={videoUrl}
              ref={videoRef}
              autoPlay
              style={{
                marginTop: "-50px",
                width: "100%",
              }}
            >
              <source src={videoUrl} type="video/mp4" />
            </video>
          )}
        </div>
      </motion.div>
    </div>
  );
};

export default QuestionAnswerOral;
